import Icon_chrono from "../../assets/images/svg/icon_chrono_order.svg"
import Icon_alpha from "../../assets/images/svg/icon_alpha_order.svg"

export default function Titulo(props: propsCabecera_titulos) {
    let titulo ='Otros títulos de la colección';
    switch (props.seccion) {
        case 1:
            titulo = 'Otros títulos del autor'
        break;
        case 2:            
            titulo = 'Otros títulos de la colección'
        break;
    }
    let orden = (tipo:number) =>{  
        props.onChange(tipo);
    } 
    return(        
        <div className="container-fluid mt-5 banner_sticky">
            <div className="row">
                <div className="col-12 back_blue px-5">
                    <h5 className="text_white mb-0 py-3 text-center">{titulo}</h5>
                </div>
            </div>
            <div className="row mb-5">
                <div className="col-12 text-center text-lg-end py-2 row_btn_order px-5">
                    <button className="btn_order d-inline-block d-sm-none me-1" onClick={() => orden(1)}><img src={Icon_chrono} height="30px" className="px-2" alt="ordenar por año" /></button>
                    <button className="btn_order d-inline-block d-sm-none ms-1" onClick={() => orden(2)}><img src={Icon_alpha} height="30px" className="px-2" alt="ordenar por alfabeto" /></button>
                    <button className="me-3 btn_order d-none d-sm-inline-block" onClick={() => orden(1)}>Ordenar por año de edición<i className="fa-solid fa-circle-chevron-down ms-2"></i></button>
                    <button className="btn_order d-none d-sm-inline-block" onClick={() => orden(2)}>Ordenar alfábeticamente<i className="fa-solid fa-circle-chevron-down ms-2"></i></button>
                </div>
            </div>
        </div>
    );  
}

interface propsCabecera_titulos {
    onChange(orden:number):void,
    seccion:number
}
